import React, { useMemo, useState } from "react";
import { FiClock, FiArrowUpRight } from "react-icons/fi";
import "./Blog.css";

const posts = [
  {
    id: 1,
    category: "Business",
    title: "Basics to Know Before Starting a New Business",
    excerpt:
      "Before launching a business, understand the essentials: branding, online presence, marketing, planning, and customer trust.",
    author: "Shyne Graphics",
    date: "Mar 14, 2026",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/9098544359779761053",
  },

  {
    id: 2,
    category: "Branding",
    title: "Roles of Logo and Website in a Business",
    excerpt:
      "Discover how your logo and website work together to create trust, improve recognition, and support business growth.",
    author: "Shyne Graphics",
    date: "Mar 12, 2026",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/5580889854279778606",
  },

  {
    id: 3,
    category: "Design",
    title: "Web Design vs Graphic Design",
    excerpt:
      "Understand the difference between web design and graphic design, and how both support a strong professional brand.",
    author: "Shyne Graphics",
    date: "Mar 10, 2026",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/4171958219534647214",
  },

  {
    id: 4,
    category: "Marketing",
    title: "Importance of Digital Marketing for Small Business",
    excerpt:
      "See why digital marketing is essential for small businesses looking to reach customers, build trust, and increase sales.",
    author: "Shyne Graphics",
    date: "Mar 8, 2026",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1557838923-2985c318be48?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/3509960722083406234",
  },

  {
    id: 5,
    category: "Marketing",
    title: "Digital Marketing in 2026",
    excerpt:
      "Explore the digital marketing strategies, tools, and trends businesses should understand to stay competitive in 2026.",
    author: "Shyne Graphics",
    date: "Mar 6, 2026",
    readTime: "7 min read",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/2996470053842747934",
  },

  {
    id: 6,
    category: "Marketing",
    title: "SEO and Paid Ads",
    excerpt:
      "Learn how SEO and paid advertising work together to help businesses increase visibility, attract customers, and grow online.",
    author: "Shyne Graphics",
    date: "Mar 4, 2026",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/6651548629871560915",
  },

  {
    id: 7,
    category: "Marketing",
    title: "SEO, GEO and AEO for Business",
    excerpt:
      "Learn how search engine optimization, generative engine optimization, and answer engine optimization help businesses get discovered.",
    author: "Shyne Graphics",
    date: "Mar 2, 2026",
    readTime: "7 min read",
    image:
      "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?auto=format&fit=crop&w=1200&q=80",
    link: "https://www.blogger.com/u/4/blog/post/edit/5311810498320337170/8267489810222711218",
  },
];

const filters = ["All", "Business", "Branding", "Design", "Marketing"];

function Blog() {
  const [activeFilter, setActiveFilter] = useState("All");

  const filteredPosts = useMemo(() => {
    if (activeFilter === "All") return posts;

    return posts.filter((post) => post.category === activeFilter);
  }, [activeFilter]);

  return (
    <section className="blogPage">
      <div className="blogPage__inner">

        <header className="blogHero">
          <span className="blogHero__eyebrow">
            Shyne Learning
          </span>

          <h1>
            Business, Branding & Marketing Guides
          </h1>

          <p>
            Explore helpful articles on digital marketing,
            branding, SEO, web design, and business growth.
          </p>

          <div
            className="blogFilters"
            role="tablist"
            aria-label="Blog categories"
          >
            {filters.map((filter) => (
              <button
                key={filter}
                className={`blogFilter ${
                  activeFilter === filter ? "is-active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
                type="button"
              >
                {filter}
              </button>
            ))}
          </div>
        </header>

        <div className="blogGrid">
          {filteredPosts.map((post) => (
            <a
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="blogCard"
              key={post.id}
            >
              <div className="blogCard__imageWrap">
                <img
                  src={post.image}
                  alt={post.title}
                  className="blogCard__image"
                />
              </div>

              <div className="blogCard__body">

                <div className="blogCard__metaTop">
                  <span className="blogTag">
                    {post.category}
                  </span>

                  <span className="blogReadTime">
                    <FiClock />
                    {post.readTime}
                  </span>
                </div>

                <h3>{post.title}</h3>

                <p>{post.excerpt}</p>

                <div className="blogCard__footer">

                  <div className="blogAuthor">
                    <div className="blogAuthor__avatar">
                      {post.author.charAt(0)}
                    </div>

                    <div>
                      <strong>{post.author}</strong>
                      <span>{post.date}</span>
                    </div>
                  </div>

                  <div
                    className="blogArrow"
                    aria-label={`Read ${post.title}`}
                  >
                    <FiArrowUpRight />
                  </div>

                </div>
              </div>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Blog;